"use strict";
/// <reference types="jquery"/>

var __importStar = this && this.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var jsondiffpatch = __importStar(require("jsondiffpatch"));
exports.default = function ($) {
    $(function () {
        $("[data-preview-task]").each(previewTask);
        $("[data-target-json]").each(initComponentInsert);
        initDocumentedConfiguration();
        $(".trace-detail-JsonDiff").each(function () {
            var $diff = $(this);
            // @ts-ignore
            $diff.html(jsondiffpatch.formatters.html.format(JSON.parse($diff.html())));
        });
        $(".trace-detail-TextDiff").each(function () {
            debugger;
            var $diff = $(this);
            var delta = $diff.html();
            var diffs = delta.split(/\t/);
            var result = "";
            for (var _i = 0, diffs_1 = diffs; _i < diffs_1.length; _i++) {
                var d = diffs_1[_i];
                var firstChar = d.charAt(0);
                var rest = decodeURI(d.substr(1));
                switch (firstChar) {
                    case "=":
                        result += "<em>" + rest + " chars</em>";
                        break;
                    case "-":
                        result += "<del>" + rest + "</del>";
                        break;
                    case "+":
                        result += "<ins>" + rest + "</ins>";
                        break;
                }
            }
            $diff.html(result);
        });
        $(".trace-detail-OldNewValue").each(function () {
            var $diff = $(this);
            var delta = JSON.parse($diff.html());
            $diff.html("<div><del>" + delta.Old + "</del></div><div><ins>" + delta.New + "</ins></div>");
        });
        $("#trace-context-form").submit(function (e) {
            e.preventDefault();
            var $form = $(this);
            $form.on("form.submit.done", function () {
                return location.reload();
            });
            $form.submitAjax();
        });
        $("body").on("click", ".reset-entity", function (e) {
            e.preventDefault();
            var $button = $(this);
            var $form = $button.parents("form");
            $button.parent(".badge").remove();
            $form.submit();
        });
    });
    /**
     * Workflow task preview
     */
    function previewTask() {
        var $button = $(this);
        $button.on("click", function () {
            var $form = $button.parents("form");
            var form = $form.get(0);
            var $popupForm = $("<form method='post' target='TaskPreview' action='/Admin/Workflows/PreviewTask'></form>").hide().appendTo($("body"));
            var $html = $(form.HtmlContent);
            var hcm = $html.data("emmet-editor");
            if (hcm) {
                hcm.save();
            }
            var $json = $(form.JsonContent);
            var jcm = $json.data("emmet-editor");
            if (jcm) {
                jcm.save();
            }
            $("<input name='TypeRender' />").val($form.find("select.ddl-render-type").val()).appendTo($popupForm);
            $("<input name='HtmlContent' />").val($html.val()).appendTo($popupForm);
            $("<input name='JsonContent' />").val($json.val()).appendTo($popupForm);
            $("<input name='Source' />").val($button.data("preview-task")).appendTo($popupForm);
            window.open("", "TaskPreview", "width=900, height=600");
            $popupForm.get(0).submit();
            $popupForm.remove();
        });
    }
    /**
     * Initialise le select de choix de type de config
     */
    function initDocumentedConfiguration() {
        $("body").on("modal.loaded", function (e) {
            $("[data-target-configuration]").each(function () {
                var $type = $(this);
                var loadDoc = function ($select) {
                    var $selected = $select.find("option:selected");
                    var $doc = $($type.data("target-doc"));
                    var doc = $selected.data("doc");
                    var html = "";
                    if (doc) {
                        html = "<ul>" + $.map(Object.keys(doc), function (k) {
                            return "<li><strong>" + k + "</strong> : " + (doc[k] || "<em>Non documenté</em>") + "</li>";
                        }).join("") + "</ul>";
                    }
                    $doc.html(html);
                };
                $type.on("change", function () {
                    var $select = $(this);
                    var $config = $($type.data("target-configuration"));
                    var $selected = $select.find("option:selected");
                    loadDoc($select);
                    if ($config.val() == "" || confirm("Le contenu de la configuration actuelle va être remplacé, souhaitez-vous continuer ?")) {
                        var json = $selected.attr("data-json");
                        $config.data("emmet-editor").setValue(json);
                        $config.val(json);
                    }
                });
                loadDoc($type);
            });
        });
    }
    /**
     * Initialise le select d'insertion de nouveau composant
     */
    function initComponentInsert() {
        var $select = $(this);
        $select.on("change", function () {
            var $json = $($select.data("target-json"));
            var editor = $json.data("codemirror");
            var doc = editor.getDoc();
            var json = $select.val();
            var select = doc.listSelections();
            var colOffset = select[0].anchor.ch;
            var pad = Array(colOffset).join(" ");
            json = json.split(/[\r\n]+/).join("\n" + pad);
            doc.replaceSelection(json);
            $json.val(doc.getValue());
            $select.val("");
        });
    }
};


//////////////////
// WEBPACK FOOTER
// C:/JenkinsWorkspace/Orezo/Orezo.Production/source/vendor/helium/src/Helium.Workflow.Mvc.Admin/_wwwsrc/js/index.ts
// module id = 679
// module chunks = 0